module.exports = __webpack_public_path__ + "static/essmart-c52aa3dd74c3da5d0ad5b0baa8065625.png";